import { env } from './env';
export const APP_DOWNLOAD_LINK = 'https://link.baobab-labs.com/oQf0/vdgeviog';
export const APP_DOWNLOAD_ONELINK = 'https://baobab.onelink.me/oQf0';
export const APP_STORE_LINK =
  'https://apps.apple.com/app/baobab-labs/id6503043086';
export const PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=com.baobab.app';
export const FEEDBACK_ORIGIN = 'https://feedback.baobab-labs.com';
export const TERMS_URL = 'https://baobab.school/terms';
export const PRIVACY_URL = 'https://baobab.school/privacy';
export const WEBSITE_PRIVACY_URL = 'https://www.baobab-labs.com/politique-de-confidentialite';
export const ONELINK_HOST = 'onelink.me';
export const APP_LINK_DOMAIN = '.baobab-labs.com';

export const PRODUCTION_APP_ORIGIN = 'https://app.baobab-labs.com';
export const STAGING_APP_ORIGIN = 'https://staging-app.baobab-labs.com';

export const getAppDownloadLink = (): string => {
  return APP_DOWNLOAD_LINK;
};

export const getBaseUrl = (): string =>
  env.mode === 'production'
    ? PRODUCTION_APP_ORIGIN
    : STAGING_APP_ORIGIN;
